<template lang="pug">
.listar-areas-table.col-12.cardContainer
    .row.d-flex.justify-content-between.px-3.py-3
        h2 {{ $t('mensagens.territorio.poligonosSelecionados') }}
        el-button(
            style='width: 150px',
            @click.stop='consolidaTerritorio',
            type='primary',
            :disabled='this.territoryTableData.length <= 1'
        )
            | {{ $t('mensagens.territorio.consolidarAreas') }}

    el-table(:data='territoryTableData', style='width: 100%')
        el-table-column(
            :label='$t("mensagens.territorio.labels.departamento")',
            min-width='200px'
        )
            .template(slot-scope='scope')
                span {{ scope.row.departamentoNome || '-' }}
        el-table-column(
            :label='$t("mensagens.territorio.labels.distrito")',
            min-width='200px'
        )
            .template(slot-scope='scope')
                span {{ scope.row.distritoNome || '-' }}
        el-table-column(
            prop='type',
            :label='$t("mensagens.territorio.labels.tipo")',
            min-width='100px'
        )
        el-table-column(
            :formatter='formatAreaHaTableColumn',
            prop='area_ha',
            :label='$t("mensagens.territorio.labels.areaHa")',
            min-width='200px'
        )
        el-table-column(
            :label='$t("mensagens.operacao.tabela.acoes")',
            width='200px',
            align='center'
        )
            .template.d-flex.justify-content-center(slot-scope='scope')
                el-button(
                    type='danger',
                    @click.stop='deleteTerritory(scope.$index, scope.row)',
                    :disabled='desabilitarRemocao'
                )
                    | {{ $t('mensagens.comuns.deletar') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import territorioService from '@/services/TerritorioService';
import localidadeService from '@/services/LocalidadeService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'listAreasTable',
    props: {
        desabilitarRemocao: {
            required: false,
            default: false
        },
        country: {
            required: false,
            default: 'BR'
        }
    },
    data() {
        return {
            loadingLocalidades: false
        };
    },
    computed: {
        ...mapGetters(['territoryTableData'])
    },
    watch: {
        territoryTableData: {
            handler(newValue, oldValue) {
                if (newValue && newValue.length > 0) {
                    this.buscarLocalidadesPorGeometria();
                }
            },
            deep: true,
            immediate: false
        }
    },
    methods: {
        ...mapActions([
            'removeTerritoryTableData',
            'clearTerritoryTableData',
            'setTerritoryTableData'
        ]),
        deleteTerritory(index, row) {
            if (row.type === 'UPLOAD') {
                this.$emit('delete-upload-file', row.fileName);
            } else {
                this.$root.$emit('remove-map-layer', row.identificadorGeometria);
                this.removeTerritoryTableData(index);
            }
            this.$emit('click-delete-area');
        },
        formatAreaHaTableColumn(row, column, areaHa, index) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        },

        async buscarLocalidadesPorGeometria() {
            if (this.loadingLocalidades) {
                return;
            }

            this.loadingLocalidades = true;

            try {
                const promises = this.territoryTableData.map(async item => {
                    try {
                        const response = await localidadeService.buscarPorGeometria(item.geometry);
                        const localidadeValida = response.data !== null && this.country === response.data.localidades[0].sigla;

                        if (!localidadeValida) {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.territorio.erroLocalidadeNaoEncontrada'
                                )
                            });

                            if (item.identificadorGeometria) {
                                this.$root.$emit('remove-map-layer', item.identificadorGeometria);
                            }

                            const index = this.territoryTableData.findIndex(
                                t => t.identificadorGeometria === item.identificadorGeometria
                            );
                            if (index !== -1) {
                                this.removeTerritoryTableData(index);
                            }

                            return null;
                        }

                        this.$set(
                            item,
                            'departamentoNome',
                            response.data.departamentoNome || '-'
                        );
                        this.$set(
                            item,
                            'distritoNome',
                            response.data.distritoNome || '-'
                        );

                        return response.data;
                    } catch (error) {
                        this.$set(item, 'departamentoNome', '-');
                        this.$set(item, 'distritoNome', '-');
                        return null;
                    }
                });

                const results = await Promise.all(promises);
                const firstValidResult = results.find(result => result !== null);

                if (firstValidResult) {
                    this.$emit('set-localidades', firstValidResult);
                }
            } catch (error) {
                // this.$notify.error({
                //     message: this.$t(
                //         'mensagens.territorio.erroBuscarLocalidades'
                //     )
                // });
            } finally {
                this.loadingLocalidades = false;
            }
        },

        consolidaTerritorio() {
            let listGeometryToSend = {
                geometries: []
            };
            this.territoryTableData.forEach(item => {
                listGeometryToSend.geometries.push({ ...item.geometry });
            });
            territorioService
                .consolidaTerritorio(listGeometryToSend)
                .then(response => {
                    EventBus.$emit(
                        'cadastro-territorio:fechar-modal-car-selecionado'
                    );
                    if (response.status === 200) {
                        this.territoryTableData.forEach(territory => {
                            this.$root.$emit(
                                'remove-map-layer',
                                territory.identificadorGeometria
                            );
                        });

                        this.clearTerritoryTableData();
                        const newTerritoryTableData = {
                            area_ha: response.data.areaTotal,
                            geometry: response.data.geometry,
                            type: response.data.tipo,
                            codigo: 'AREA_CONSOLIDADA',
                            identificadorGeometria: new Date().getTime()
                        };

                        this.setTerritoryTableData(newTerritoryTableData);
                        this.$store.dispatch('setShowCamadaToEdit', {
                            showCamadaToEdit: true,
                            geometriaToShow: newTerritoryTableData.geometry,
                            identificadorGeometria: newTerritoryTableData.identificadorGeometria
                        });
                        this.$notify.success({
                            message: this.$t(
                                'mensagens.territorio.territorioConsolidadoComSucesso'
                            )
                        });
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.erroAoConsolidarTerritorios'
                            )
                        });
                    }
                });
        }
    }
};
</script>

<style lang="scss">
.listar-areas-table {
    .el-table {
        border-radius: 5px;
        th {
            color: var(--primary);
        }
    }

    .fullHeight {
        height: 100%;
    }

    .cardContainer {
        background-color: var(--white);
        border-radius: 5px;
        padding: 20px;
    }

    .btnDisabled {
        color: var(--disabled-font-color);
        background-color: var(--default-background-color);
        border-color: var(--default-border-color);
        cursor: not-allowed !important;
        pointer-events: none !important;
    }
}
</style>
